import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { DEBOUNCE_TIME, isSameIdSelection } from '../../../UserActivity.meta';

export const useFilterDraft = (initialSelectedIds: string[]) => {
  const [selectedIds, setSelectedIds] = useState(() => initialSelectedIds);
  const [searchSelectedIds, setSearchSelectedIds] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm] = useDebounce(searchTerm, DEBOUNCE_TIME);

  const initialSelectedIdsKey = initialSelectedIds.join('\0');

  useEffect(() => {
    setSelectedIds(prev =>
      isSameIdSelection(prev, initialSelectedIds) ? prev : initialSelectedIds,
    );
    setSearchSelectedIds(prev =>
      isSameIdSelection(prev, initialSelectedIds) ? prev : initialSelectedIds,
    );
    setSearchTerm('');
  }, [initialSelectedIdsKey]);

  const effectiveIds = debouncedSearchTerm ? searchSelectedIds : selectedIds;

  const reset = () => {
    setSelectedIds([]);
    setSearchSelectedIds([]);
    setSearchTerm('');
  };

  return {
    selectedIds,
    searchSelectedIds,
    searchTerm,
    debouncedSearchTerm,
    effectiveIds,
    setSelectedIds,
    setSearchSelectedIds,
    setSearchTerm,
    reset,
  };
};
